/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wood_Normal_LevelInputs */



/**
* | output |
* | --- |
* | "Wood silo level: normal" |
*
* @param {Wood_Normal_LevelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const wood_normal_level = /** @type {((inputs?: Wood_Normal_LevelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wood_Normal_LevelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Wood silo level: normal")
	return /** @type {LocalizedString} */ ("Niveau du silo bois : normal")
});